// extracted by mini-css-extract-plugin
export default {"mainDiv":"PageNotFound_mainDiv__4-BCM","flexContainer":"PageNotFound_flexContainer__1JSVQ","homeButton":"PageNotFound_homeButton__jSSaN"};